export const displayCurrency = (sum = 0) => {
  return String(sum).replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$& ');
};
